import LoginPage from "beaktShared/views/GenericPages/LoginPage.js";
import Home from "beaktAdmin/views/Home.js";
import FranquiaList from "beaktAdmin/views/Cadastros/FranquiaList.js";

// @material-ui/icons
import HomeIcon from "@material-ui/icons/Home";
import Settings from "@material-ui/icons/Settings";

var Routes = [
  {
    path: "/login",
    name: "login",
    mini: "L",
    component: LoginPage,
    layout: "/auth",
    showmenu: false
  },
  {
    path: "/home",
    name: "home",
    mini: "H",
    icon: HomeIcon,
    component: Home,
    layout: "/admin",
    showmenu: true
  },  
  {
    path: "/franquia",
    name: "franchise",
    mini: "F",
    icon: Settings,
    component: FranquiaList,
    layout: "/admin",
    showmenu: true
  }, 
];
export default Routes;
